import moment from "jalali-moment";
import { formats } from "./formats";
import { applyManipulations, createResult } from "./helpers";
import { DateUtilsNowResult, Now } from "./types";

export function jalaliNow({ toFormat = formats.standard.jalaliDateTime, manipulate }: Now = {}): DateUtilsNowResult {
  try {
    let faDate = moment().locale("fa");

    if (manipulate?.length) {
      faDate = applyManipulations(faDate, manipulate);
    }

    return createResult<DateUtilsNowResult>({ object: faDate, toFormat });
  } catch (error) {
    return createResult({ fallback: "" });
  }
}

export function utcNow({ toFormat = formats.standard.utcDateTime, manipulate }: Now = {}): DateUtilsNowResult {
  try {
    let utcDate = moment.utc();

    if (manipulate?.length) {
      utcDate = applyManipulations(utcDate, manipulate);
    }

    return createResult<DateUtilsNowResult>({ object: utcDate, toFormat });
  } catch (error) {
    return createResult({ fallback: "" });
  }
}
